import { removeUndefinedFields } from "../helper";

export const QUESTIONS = [
  {
    label: "Fuel level in tank",
    options: [
      { label: "Observed Fully filled", apiOptionKey: "observedFullyFilled" },
      {
        label: "Observed Half tank filled",
        apiOptionKey: "observedHalfTankFilled",
      },
      {
        label: "Observed No fuel in tank",
        apiOptionKey: "observedNoFuelInTank",
      },
    ],
  },
  {
    label: "Fuel Tank Stainer Condition",
    options: [
      {
        label: "Found Clean and no blockage observed",
        apiOptionKey: "foundCleanAndNoBlockageObserved",
      },
      { label: "Found Blockage", apiOptionKey: "foundBlockage" },
    ],
  },
  {
    label: "Breather System in Fuel Tank",
    options: [
      { label: "Found ok", apiOptionKey: "q3o1" },
      { label: "Found blockage", apiOptionKey: "foundBlockageBreather" },
      {
        label: "No Breather system in Fuel tank",
        apiOptionKey: "noBreatherSystemInfuelTank",
      },
    ],
  },
  {
    label: "Fuel Stop lever condition observed",
    options: [
      { label: "At Rest position", apiOptionKey: "atRestPosition" },
      {
        label: "At partial pull condition",
        apiOptionKey: "atPartialPullCondition",
      },
      {
        label: "At fully pulled condition	",
        apiOptionKey: "atFullyPulledCondition",
      },
    ],
  },
  {
    label: "Fuel supply Condition",
    options: [
      {
        label: "Found Air in fuel system",
        apiOptionKey: "foundAirInFuelSystem",
      },
      {
        label: "Found low pressure pipe blocked",
        apiOptionKey: "foundLowPressurePipeBlocked",
      },
      {
        label: "Found low pressure pipe bend",
        apiOptionKey: "foundLowpressurePipeBend",
      },
      {
        label: "Found Fuel hose banjo washer damage",
        apiOptionKey: "foundFuelHoseBanjoWasherDamage",
      },
      {
        label: "Found overflow valve faulty",
        apiOptionKey: "foundOverflowValveFaulty",
      },
      {
        label: "Found fuel leakage in Low pressure pipes",
        apiOptionKey: "foundFuelLeakageInLowPressurePipes",
      },
    ],
  },
  {
    label:
      "Fuel Low pressure hoses inlet diameter(mm (Note : Minimum 8 mm required))",
    type: "INPUT",
    apiKey: "fuelLowPressureHosesInletDiameter",
    keyboardType: "numeric",
    options: [],
  },
  {
    label: "Fuel Filter condition",
    options: [
      { label: "Found ok", apiOptionKey: "q6o1" },
      { label: "Found clogged", apiOptionKey: "foundClogged" },
      { label: "Found damaged", apiOptionKey: "foundDamaged" },
      { label: "Found Water in filter", apiOptionKey: "foundWaterInFilter" },
      {
        label: "Found fuel Inlet and outlet hoses are interchanged.",
        apiOptionKey: "foundFuelInletAndOutletHosesAreInterchanged",
      },
    ],
  },
  {
    label: "Fuel Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q7o1" },
      { label: "Found fuel adulterated	", apiOptionKey: "foundFuelAdulterated" },
    ],
  },

  {
    label: "Fuel Pump Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q9o1" },
      { label: "Found pump faulty", apiOptionKey: "foundPumpFaulty" },
    ],
  },
  {
    label: "Fuel Injector Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q10o1" },
      {
        label: "Found 1st Injector faulty",
        apiOptionKey: "foundFirstInjectorFaulty",
      },
      {
        label: "Found 2nd Injector faulty",
        apiOptionKey: "foundSecondInjectorFaulty",
      },
      {
        label: "Found 3rd Injector faulty",
        apiOptionKey: "foundThirdInjectorFaulty",
      },
      {
        label: "Found 4th Injector faulty",
        apiOptionKey: "foundFourthInjectorFaulty",
      },
    ],
  },
  {
    label: "Common Rail condition",
    options: [
      { label: "Found ok", apiOptionKey: "q11o1" },
      {
        label: "Found fuel leak from Pressure relief valve	",
        apiOptionKey: "foundFuelLeakFromPressureReliefValve",
      },
    ],
  },
];

export const mappingDetailsToUIFuelSystem = (details) => {
  const {
    fuelLevelInTank = {},
    fuelTankStainerCondition = {},
    breatherSystemInFuelTank = {},
    fuelStopLeverConditionObserved = {},
    fuelSupplyCondition = {},
    fuelLowPressureHosesInletDiameter = null,
    fuelFilterCondition = {},
    fuelCondition = {},
    fuelPumpCondition = {},
    fuelInjectorCondition = {},
    commonRailCondition = {},
  } = details;

  let responseDetails = {
    observedFullyFilled: fuelLevelInTank?.observedFullyFilled,
    observedHalfTankFilled: fuelLevelInTank?.observedHalfTankFilled,
    observedNoFuelInTank: fuelLevelInTank?.observedNoFuelInTank,

    foundCleanAndNoBlockageObserved:
      fuelTankStainerCondition?.foundCleanAndNoBlockageObserved,
    foundBlockage: fuelTankStainerCondition?.foundBlockage,

    q3o1: breatherSystemInFuelTank?.foundOk,
    foundBlockageBreather: breatherSystemInFuelTank?.foundBlockage,
    noBreatherSystemInfuelTank:
      breatherSystemInFuelTank?.noBreatherSystemInfuelTank,

    atRestPosition: fuelStopLeverConditionObserved?.atRestPosition,
    atPartialPullCondition:
      fuelStopLeverConditionObserved?.atPartialPullCondition,
    atFullyPulledCondition:
      fuelStopLeverConditionObserved?.atFullyPulledCondition,

    foundAirInFuelSystem: fuelSupplyCondition?.foundAirInFuelSystem,
    foundLowPressurePipeBlocked:
      fuelSupplyCondition?.foundLowPressurePipeBlocked,
    foundLowpressurePipeBend: fuelSupplyCondition?.foundLowpressurePipeBend,
    foundFuelHoseBanjoWasherDamage:
      fuelSupplyCondition?.foundFuelHoseBanjoWasherDamage,
    foundOverflowValveFaulty: fuelSupplyCondition?.foundOverflowValveFaulty,
    foundFuelLeakageInLowPressurePipes:
      fuelSupplyCondition?.foundFuelLeakageInLowPressurePipes,

    q6o1: fuelFilterCondition?.foundOk,
    foundClogged: fuelFilterCondition?.foundClogged,
    foundDamaged: fuelFilterCondition?.foundDamaged,
    foundWaterInFilter: fuelFilterCondition?.foundWaterInFilter,
    foundFuelInletAndOutletHosesAreInterchanged:
      fuelFilterCondition?.foundFuelInletAndOutletHosesAreInterchanged,

    q7o1: fuelCondition?.foundOk,
    foundFuelAdulterated: fuelCondition?.foundFuelAdulterated,

    foundAdvanceInDegreePerMM: fuelCondition?.foundAdvanceInDegreePerMM,
    foundRetardInDegreePerMM: fuelCondition?.foundRetardInDegreePerMM,

    q9o1: fuelPumpCondition?.foundOk,
    foundPumpFaulty: fuelPumpCondition?.foundPumpFaulty,

    q10o1: fuelInjectorCondition?.foundOk,
    foundFirstInjectorFaulty: fuelInjectorCondition?.foundFirstInjectorFaulty,
    foundSecondInjectorFaulty: fuelInjectorCondition?.foundSecondInjectorFaulty,
    foundThirdInjectorFaulty: fuelInjectorCondition?.foundThirdInjectorFaulty,
    foundFourthInjectorFaulty: fuelInjectorCondition?.foundFourthInjectorFaulty,

    q11o1: commonRailCondition?.foundOk,
    foundFuelLeakFromPressureReliefValve:
      commonRailCondition?.foundFuelLeakFromPressureReliefValve,

    fuelLowPressureHosesInletDiameter:
      fuelLowPressureHosesInletDiameter != null
        ? `${fuelLowPressureHosesInletDiameter}`
        : "",
  };

  return responseDetails;
};

export const infantChecklistFuelSystem = (payload) => {
  const {
    observedFullyFilled,
    observedHalfTankFilled,
    observedNoFuelInTank,

    foundCleanAndNoBlockageObserved,
    foundBlockage,

    q3o1,
    foundBlockageBreather,
    noBreatherSystemInfuelTank,

    atRestPosition,
    atPartialPullCondition,
    atFullyPulledCondition,

    foundAirInFuelSystem,
    foundLowPressurePipeBlocked,
    foundLowpressurePipeBend,
    foundFuelHoseBanjoWasherDamage,
    foundOverflowValveFaulty,
    foundFuelLeakageInLowPressurePipes,

    q6o1,
    foundClogged,
    foundDamaged,
    foundWaterInFilter,
    foundFuelInletAndOutletHosesAreInterchanged,

    q7o1,
    foundFuelAdulterated,

    foundAdvanceInDegreePerMM,
    foundRetardInDegreePerMM,

    q9o1,
    foundPumpFaulty,

    q10o1,
    foundFirstInjectorFaulty,
    foundSecondInjectorFaulty,
    foundThirdInjectorFaulty,
    foundFourthInjectorFaulty,

    q11o1,
    foundFuelLeakFromPressureReliefValve,
    fuelLowPressureHosesInletDiameter,
  } = payload;
  let requestPayload = {};

  if (observedFullyFilled || observedHalfTankFilled || observedNoFuelInTank) {
    requestPayload.fuelLevelInTank = {
      observedFullyFilled,
      observedHalfTankFilled,
      observedNoFuelInTank,
    };
  }

  if (foundCleanAndNoBlockageObserved || foundBlockage) {
    requestPayload.fuelTankStainerCondition = {
      foundCleanAndNoBlockageObserved,
      foundBlockage,
    };
  }

  if (q3o1 || foundBlockageBreather || noBreatherSystemInfuelTank) {
    requestPayload.breatherSystemInFuelTank = {
      foundOk: q3o1,
      foundBlockage: foundBlockageBreather,
      noBreatherSystemInfuelTank,
    };
  }

  if (atRestPosition || atPartialPullCondition || atFullyPulledCondition) {
    requestPayload.fuelStopLeverConditionObserved = {
      atRestPosition,
      atPartialPullCondition,
      atFullyPulledCondition,
    };
  }

  if (
    foundAirInFuelSystem ||
    foundLowPressurePipeBlocked ||
    foundLowpressurePipeBend ||
    foundFuelHoseBanjoWasherDamage ||
    foundOverflowValveFaulty ||
    foundFuelLeakageInLowPressurePipes
  ) {
    requestPayload.fuelSupplyCondition = {
      foundAirInFuelSystem,
      foundLowPressurePipeBlocked,
      foundLowpressurePipeBend,
      foundFuelHoseBanjoWasherDamage,
      foundOverflowValveFaulty,
      foundFuelLeakageInLowPressurePipes,
    };
  }

  if (
    q6o1 ||
    foundClogged ||
    foundDamaged ||
    foundWaterInFilter ||
    foundFuelInletAndOutletHosesAreInterchanged
  ) {
    requestPayload.fuelFilterCondition = {
      foundOk: q6o1,
      foundClogged,
      foundDamaged,
      foundWaterInFilter,
      foundFuelInletAndOutletHosesAreInterchanged,
    };
  }

  if (q7o1 || foundFuelAdulterated) {
    requestPayload.fuelCondition = {
      foundOk: q7o1,
      foundFuelAdulterated,
    };
  }

  if (q9o1 || foundPumpFaulty) {
    requestPayload.fuelPumpCondition = {
      foundOk: q9o1,
      foundPumpFaulty,
    };
  }

  if (
    q10o1 ||
    foundFirstInjectorFaulty ||
    foundSecondInjectorFaulty ||
    foundThirdInjectorFaulty ||
    foundFourthInjectorFaulty
  ) {
    requestPayload.fuelInjectorCondition = {
      foundOk: q10o1,
      foundFirstInjectorFaulty,
      foundSecondInjectorFaulty,
      foundThirdInjectorFaulty,
      foundFourthInjectorFaulty,
    };
  }

  if (q11o1 || foundFuelLeakFromPressureReliefValve) {
    requestPayload.commonRailCondition = {
      foundOk: q11o1,
      foundFuelLeakFromPressureReliefValve,
    };
  }

  if (fuelLowPressureHosesInletDiameter) {
    requestPayload.fuelLowPressureHosesInletDiameter =
      +fuelLowPressureHosesInletDiameter;
  }
  const cleanedPayload = removeUndefinedFields(requestPayload);
  return cleanedPayload;
};
